module.exports = __webpack_public_path__ + "img/blablabla.7534c0b4.svg";